import { Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { Product } from '../../interfaces/product';
import { FormControl } from '@angular/forms';
import { CartService } from '../../services/cart.service';
import { RootService } from '../../services/root.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { WishlistService } from '../../services/wishlist.service';
import { ToastrService } from 'ngx-toastr';

export type ProductLayout = 'standard' | 'sidebar' | 'columnar' | 'quickview';

@Component({
    selector: 'app-product',
    templateUrl: './product.component.html',
    styleUrls: ['./product.component.scss']
})
export class ProductComponent {
    @Input() layout: ProductLayout;

    @Input() product: Product;

    quantity: FormControl = new FormControl(1);

    addingToCart = false;
    addingToWishlist = false;
    addingToCompare = false;
    buyingNow = false;


    constructor(
        @Inject(PLATFORM_ID) private platformId: any,
        private cart: CartService,
        public root: RootService,
        private router: Router,
        private wishlist: WishlistService,
        private toster:ToastrService
 

    ) {
   
    }
    isuk:boolean = false;
    ngOnInit(){
        var abc =window.location.href;
        if(abc.includes('.co.uk')){
            console.log('Redirecting to UK site');
            this.isuk = true;
        }
        else
        {
            console.log('Redirecting to Pakistan site');
        }       
         console.log(this.product)
         this.product.images.push(this.product.thumbnail)
    }
    addToCart(): void {
        if (!this.addingToCart && this.product && this.quantity.value > 0) {
            this.addingToCart = true;
            var prod = { ...this.product };
            prod = JSON.parse(JSON.stringify(prod));

            delete prod.images;
            delete prod._id;

            prod.thumbnail = environment.baseurl + prod.thumbnail;

            this.cart.add(prod, this.quantity.value).subscribe({ complete: () => this.addingToCart = false });
        }
    }
    buyNow(): void {
        if (!this.buyingNow && this.product && this.quantity.value > 0) {
            this.buyingNow = true;
            var prod = { ...this.product };
            prod = JSON.parse(JSON.stringify(prod));

            delete prod.images;
            delete prod._id;

            prod.thumbnail = environment.baseurl + prod.thumbnail;

            this.cart.add(prod, this.quantity.value).subscribe({
                complete: () => {

                    this.buyingNow = false
                    this.router.navigate(['/shop/cart/checkout'])
                }
            });

        }
    }
    getquote(){
        // this.router.navigate(['/home/getquote']);
        console.log(this.quantity)
        var value = ' ( Part Number:  '+this.product.name+' Quantity:  '+ this.quantity.value+'  )  '
        this.router.navigate(['/home/getquote/'+value])
    }
    addToWishlist(): void {
        if (!this.addingToWishlist && this.product) {
            this.addingToWishlist = true;

            this.wishlist.add(this.product).subscribe({complete: () =>{this.addingToWishlist = false
                this.toster.success('Product added to wishlist')
            
            } 
            
            });
        }
    }
}
